/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailService } from '../../services/email.service';

@Component({
  selector: 'edit-address',
  templateUrl: './edit-address.component.html',
  styleUrls: ['./edit-address.component.less'],
  standalone: false,
})
export class EditAddressComponent implements OnInit {
  @Input() type: AddressType;
  @Input() address: string;

  error: string;
  maxlength: number;

  constructor(
    public activeModal: NgbActiveModal,
    private emailService: EmailService,
  ) {}

  ngOnInit() {
    this.maxlength =
      this.type === AddressType.email
        ? this.emailService.maxEmailLength
        : this.emailService.maxDomainLength;
  }

  async save(f: NgForm) {
    this.error = '';

    if (!this.address) {
      f.form.get('address')?.setErrors({ customerror: true });
      setTimeout(() => {
        this.error = 'SDE_REQUIRED_FIELD1';
      });
      return;
    }

    if (this.type === AddressType.email) {
      if (!this.emailService.isValidEmailAddress(this.address)) {
        setTimeout(() => {
          this.error = 'SDE_EMAIL_NOT_VALID';
        });
        f.form.get('address')?.setErrors({ customerror: true });
        return;
      }
    } else if (this.type === AddressType.domain) {
      if (!this.emailService.isValidDomain(this.address)) {
        setTimeout(() => {
          this.error = 'SDE_DOMAIN_NOT_VALID';
        });
        f.form.get('address')?.setErrors({ customerror: true });
        return;
      }
    }

    // valid, return the value
    this.activeModal.close(this.address);
  }
}
export enum AddressType {
  email = 0,
  domain,
}
